var map = {
	"./locale-provider/ar_EG.tsx": 981,
	"./locale-provider/bg_BG.tsx": 985,
	"./locale-provider/ca_ES.tsx": 989,
	"./locale-provider/cs_CZ.tsx": 993,
	"./locale-provider/de_DE.tsx": 997,
	"./locale-provider/el_GR.tsx": 1001,
	"./locale-provider/en_GB.tsx": 1005,
	"./locale-provider/en_US.tsx": 1009,
	"./locale-provider/es_ES.tsx": 1010,
	"./locale-provider/et_EE.tsx": 1014,
	"./locale-provider/fa_IR.tsx": 1018,
	"./locale-provider/fi_FI.tsx": 1022,
	"./locale-provider/fr_BE.tsx": 1026,
	"./locale-provider/fr_FR.tsx": 1030,
	"./locale-provider/is_IS.tsx": 1034,
	"./locale-provider/it_IT.tsx": 1038,
	"./locale-provider/ja_JP.tsx": 1042,
	"./locale-provider/ko_KR.tsx": 1046,
	"./locale-provider/nb_NO.tsx": 1050,
	"./locale-provider/nl_BE.tsx": 1054,
	"./locale-provider/nl_NL.tsx": 1058,
	"./locale-provider/pl_PL.tsx": 1062,
	"./locale-provider/pt_BR.tsx": 1066,
	"./locale-provider/pt_PT.tsx": 1070,
	"./locale-provider/ru_RU.tsx": 1074,
	"./locale-provider/sk_SK.tsx": 1078,
	"./locale-provider/sr_RS.tsx": 1082,
	"./locale-provider/sv_SE.tsx": 1086,
	"./locale-provider/th_TH.tsx": 1090,
	"./locale-provider/tr_TR.tsx": 1094,
	"./locale-provider/uk_UA.tsx": 1096,
	"./locale-provider/vi_VN.tsx": 1100,
	"./locale-provider/zh_CN.tsx": 1104,
	"./locale-provider/zh_TW.tsx": 1107
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 980;


//////////////////
// WEBPACK FOOTER
// ./components ^\.\/locale-provider\/.+_.+\.tsx$
// module id = 980
// module chunks = 0